import type { StaffApiSchema } from "../../api_utils";

export type PrimacyTier = StaffApiSchema.components["schemas"]["TierEnum"];

export const PRIMACY_TIERS: readonly PrimacyTier[] = ["low", "moderate", "high"];

export const TIER_LABELS: Record<PrimacyTier, string> = {
  low: "Low",
  moderate: "Moderate",
  high: "High",
};
